import React from 'react';

import { Button } from '../../button';

type PageButtonProps = {
  label: string;
  children: React.ReactNode;
  isActive?: boolean;
  disabled?: boolean;
  onClick: () => void;
};

export const PageButton = ({
  label,
  children,
  isActive,
  disabled,
  onClick,
}: PageButtonProps): JSX.Element => (
  <Button
    disabled={disabled}
    variant={isActive ? 'teal' : 'ghost'}
    aria-label={label}
    title={label}
    active={isActive}
    onClick={onClick}
    size="sm"
  >
    {children}
  </Button>
);
